
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from "@angular/common/http";
import { HttpService } from './httpService';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(
    private httpService: HttpService,
    private datePipe: DatePipe,) { }

  async checkSubscription() {
    let isSubscribed = false;
    let msisdn = localStorage.getItem('msisdn');
    if (msisdn != null && msisdn != undefined && msisdn != "") {
      let url = environment.serviceUrl + 'kesafmu/check/' + msisdn;
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendGetRequest(url, options);
      console.log("SubscriptionService | checkSubscription => ", response ? JSON.stringify(response) : null);
      if (response && response['success']) {
        let subscribeStatus = response['data'][0]['issubscribed'];
        sessionStorage.setItem('isSubscribed', subscribeStatus);
        console.log("sessionStorage.setItem('isSubscribed').........................", subscribeStatus);

        if (subscribeStatus == '1') {
          isSubscribed = true;
          sessionStorage.setItem('subscriptionDate', response['data'][0]['activation_date']);
          sessionStorage.setItem('renewalDate', response['data'][0]['expiry_date']);
          sessionStorage.setItem('unsubDate', response['data'][0]['unsubdate']);
          sessionStorage.setItem('isNewUser', response['data'][0]['isnewuser']);
        }
      }
    } else {
      sessionStorage.setItem('isSubscribed', "");
    }
    return isSubscribed;
  }

  //getCGDetails
  async getCGDetails() {
    let msg;
    let msisdn = localStorage.getItem('msisdn');
    let requestId = Number(new Date());
    if (msisdn != null && msisdn != undefined && msisdn != "") {
      let url = environment.serviceUrl + 'kesafmu/getCGDetails' + "?requestId=" + requestId;;
      let postData = {
        "data": {
          "msisdn": msisdn,
          "useragent": sessionStorage.getItem('userAgent') ?? "",
          "portal": environment.portal,
          "country": environment.country,
          "operator": environment.operator,
          "service": environment.service,
          "source": sessionStorage.getItem('source') ?? "",
          "referer": sessionStorage.getItem('referer') ?? "",
          "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
          "pubid": sessionStorage.getItem('pubId') ?? "",
          "clickid": sessionStorage.getItem('clickId') ?? "",
          "lpvisitorid": sessionStorage.getItem('lpvisitorId') ? sessionStorage.getItem('lpvisitorId') : "0",
          "visitorid": "0",
          "consentid": requestId.toString(),
          "callBackUrl": "https://gkvas-service.gamezklub.com/gkvas-service/v1/kesafmu/notification"
        }
      }
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendPostRequest(url, postData, options);
      console.log("SubscriptionService | getCGDetails => ", response ? JSON.stringify(response) : null);
      if (response && response['success']) {
        // console.log('response..............', response['data']);

        // let status = response['data']['body']['status'];
        // msg = response['data']['body']['description'];
        // localStorage.setItem('msg', msg)
        let consent_url = response['data']['consent_url'];
        localStorage.setItem('redirectsub', '1')
        // window.location.href = 'https://safaricom.com/consent?sessionId=' + sessionId;
        console.log('consent_url............', consent_url);
        window.location.href = consent_url;

      }
    } else {
      sessionStorage.setItem('isSubscribed', "");
    }
    return msg
  }

  //insert CG Log

  async insertCGLog() {
    let msisdn = localStorage.getItem('msisdn');
    let requestId = Number(new Date());
    if (msisdn != null && msisdn != undefined && msisdn != "") {
      let url = environment.serviceUrl + 'kesafmu/insertCG' + "?requestId=" + requestId;
      let postData = {
        "data": {
          "msisdn": msisdn,
          "useragent": sessionStorage.getItem('userAgent') ?? "",
          "portal": environment.portal,
          "country": environment.country,
          "operator": environment.operator,
          "service": environment.service,
          "source": sessionStorage.getItem('source') ?? "",
          "referer": sessionStorage.getItem('referer') ?? "",
          "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
          "pubid": sessionStorage.getItem('pubId') ?? "",
          "clickid": sessionStorage.getItem('clickId') ?? "",
          "lpvisitorid": sessionStorage.getItem('lpvisitorId') ? sessionStorage.getItem('lpvisitorId') : "0",
          "visitorid": sessionStorage.getItem('visitorId') ? sessionStorage.getItem('visitorId') : "0",
          "consentid": requestId.toString(),
        }
      }
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendPostRequest(url, postData, options);
      console.log("SubscriptionService | checkSubscription => ", response ? JSON.stringify(response) : null);
      if (response && response['success']) {

      }
    }
  }

  //unsubcribe

  async unsubcribe() {
    let msisdn = localStorage.getItem('msisdn');
    let requestId = Number(new Date());
    if (msisdn != null && msisdn != undefined && msisdn != "") {
      let url = environment.serviceUrl + 'kesafmu/deactivate' + "?requestId=" + requestId;
      let postData = {
        "data": {
          "msisdn": msisdn,
          "useragent": sessionStorage.getItem('userAgent') ?? "",
          "portal": environment.portal,
          "country": environment.country,
          "operator": environment.operator,
          "service": environment.service,
          "source": sessionStorage.getItem('source') ?? "",
          "referer": sessionStorage.getItem('referer') ?? "",
          "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
          "pubid": sessionStorage.getItem('pubId') ?? "",
          "clickid": sessionStorage.getItem('clickId') ?? "",
          "visitorid": sessionStorage.getItem('visitorId') ? sessionStorage.getItem('visitorId') : '0',
          "consentid": "0",
        }
      }
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendPostRequest(url, postData, options);
      console.log("SubscriptionService | unsubcribe => ", response ? JSON.stringify(response) : null);
      if (response && response['success']) {
        sessionStorage.removeItem('activation_date');
        sessionStorage.removeItem('expiry_date');
        sessionStorage.removeItem('isSubscribed');
        sessionStorage.removeItem('isnewuser');
        sessionStorage.clear();
      }
    }
  }

  async checkDateDifference() {
    let isDifferenceDays = false;
    let current_date = this.datePipe.transform(Date.now(), 'yyyy-MM-dd');
    let unsub_date = this.datePipe.transform(new Date('2023-06-02'), 'yyyy-MM-dd');
    const Difference_In_Time = new Date(current_date).getTime() - new Date(unsub_date).getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    let differenceDays = Difference_In_Days;
    console.log("Total number .........", differenceDays > 30);
    console.log("Total number of days between dates .........", differenceDays);
    if (differenceDays > 30) {
      isDifferenceDays = true;
    }
    else {
      isDifferenceDays = false;

    }
    // console.log("Total number .........", this.differenceDays > 45);
    console.log("Total number of days between dates .........", differenceDays);
    return isDifferenceDays
  }

}
